// Confirmation de paiement (apiEtsy.php::addPayment) fiable : le paiement PayPal est déjà capturé
// quand on prévient le site, donc cette confirmation ne doit pas se perdre (page fermée, coupure
// réseau). Elle est mémorisée dans le navigateur avant l'envoi, envoyée avec `keepalive` (la
// requête survit à la fermeture de la page), retentée, et rejouée à la visite suivante tant que
// le serveur ne l'a pas acquittée. addPayment ignore un appel rejoué (commande déjà payée).
import { API_BASE, CLE_API } from './apiBase';

const CLE_STOCKAGE = 'jpm_paiements_en_attente';
const DUREE_MAX_MS = 30 * 24 * 3600 * 1000;

const lire = () => {
  try {
    const liste = JSON.parse(localStorage.getItem(CLE_STOCKAGE) || '[]');
    return Array.isArray(liste) ? liste : [];
  } catch {
    return [];
  }
};

const ecrire = (liste) => {
  try {
    localStorage.setItem(CLE_STOCKAGE, JSON.stringify(liste));
  } catch {}
};

const retirer = (cmdIncrement) => ecrire(lire().filter((p) => p.cmd_increment !== cmdIncrement));

const envoyer = async (paiement) => {
  const { ts, ...params } = paiement;
  const url = `${API_BASE}/apiEtsy.php?${new URLSearchParams({ cleApi: CLE_API, service: 'addPayment', ...params })}`;
  const reponse = await fetch(url, { keepalive: true });
  const texte = await reponse.text();
  // La réponse peut contenir deux JSON accolés : seul le premier compte.
  const premier = JSON.parse(texte.includes('}{') ? `${texte.split('}{')[0]}}` : texte);
  return Boolean(premier && premier.success);
};

const attendre = (ms) => new Promise((r) => setTimeout(r, ms));

// Mémorise puis envoie ; résout à true dès que le serveur a acquitté (3 essais), false sinon
// (la confirmation reste alors en attente et sera rejouée).
export const confirmerPaiement = async (params) => {
  const paiement = { ...params, ts: Date.now() };
  ecrire([...lire().filter((p) => p.cmd_increment !== paiement.cmd_increment), paiement]);
  for (let essai = 0; essai < 3; essai++) {
    try {
      if (await envoyer(paiement)) {
        retirer(paiement.cmd_increment);
        return true;
      }
    } catch {}
    if (essai < 2) await attendre(2000 * (essai + 1));
  }
  return false;
};

// Au chargement du site : renvoie les confirmations restées en attente.
export const rejouerPaiementsEnAttente = async () => {
  for (const paiement of lire()) {
    if (Date.now() - Number(paiement.ts || 0) > DUREE_MAX_MS) {
      retirer(paiement.cmd_increment);
      continue;
    }
    try {
      if (await envoyer(paiement)) retirer(paiement.cmd_increment);
    } catch {}
  }
};
